import { render, staticRenderFns } from "./import-csv.vue?vue&type=template&id=025d2345&scoped=true&"
import script from "./import-csv.vue?vue&type=script&lang=js&"
export * from "./import-csv.vue?vue&type=script&lang=js&"
import style0 from "./import-csv.vue?vue&type=style&index=0&id=025d2345&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "025d2345",
  null
  
)

export default component.exports